<template>
  <div ref="infiniteLoader" class="infinite-loader" />
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['infinite'],
  data() {
    return {
      intersectionObserver: null,
    }
  },
  mounted() {
    if (!('IntersectionObserver' in window)) return
    this.intersectionObserver = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        if (!this.disabled) this.$emit('infinite')
      }
    })
    this.intersectionObserver.observe(this.$refs.infiniteLoader)
  },
  beforeUnmount() {
    if (this.intersectionObserver) this.intersectionObserver.unobserve(this.$refs.infiniteLoader)
  },
}
</script>
